// ============================================================
// Staff API — Staff Management
// ============================================================

import client from './axios';
import { staffDocumentsApi } from './staffDocuments.api';

export const staffApi = {
  getAll: async (schoolId, params = {}) => {
    const queryParams = {
      school_id: schoolId,
      ...params,
    };
    const response = await client.get('/staff/', { params: queryParams });
    return response.data;
  },

  getById: async (id, schoolId) => {
    const response = await client.get('/staff/staff-by-id', {
      params: { staff_id: id, school_id: schoolId },
    });
    return response.data;
  },

  getProfile: async (id, schoolId) => {
    const response = await client.get(`/staff/${id}/profile`, {
      params: { school_id: schoolId },
    });
    return response.data;
  },

  create: async (schoolId, payload) => {
    const response = await client.post(`/staff/?school_id=${schoolId}`, payload);
    return response.data;
  },

  update: async (id, schoolId, payload) => {
    const response = await client.put(`/staff/${id}?school_id=${schoolId}`, payload);
    return response.data;
  },

  updateStatus: async (id, schoolId, employmentStatus) => {
    const statusVal =
      typeof employmentStatus === 'object' && employmentStatus !== null
        ? employmentStatus.employment_status || employmentStatus.employmentStatus || employmentStatus.status
        : employmentStatus;

    const response = await client.patch(
      `/staff/${id}/status?school_id=${schoolId}`,
      { employment_status: statusVal }
    );
    return response.data;
  },

  delete: async (id, schoolId) => {
    const response = await client.delete(`/staff/${id}?school_id=${schoolId}`);
    return response.data;
  },

  // Document methods forwarded to staffDocumentsApi
  getDocuments: (staffId, schoolId) => staffDocumentsApi.getAll(staffId, schoolId),
  getDocumentById: (documentId, staffId, schoolId) => staffDocumentsApi.getById(documentId, staffId, schoolId),
  createDocument: (staffId, schoolId, payload) => staffDocumentsApi.create(staffId, schoolId, payload),
  updateDocument: (documentId, staffId, schoolId, payload) => staffDocumentsApi.update(documentId, staffId, schoolId, payload),
  deleteDocument: (documentId, staffId, schoolId) => staffDocumentsApi.delete(documentId, staffId, schoolId),
};
